import React from "react";
import { string, arrayOf, shape, bool, number, oneOf } from "prop-types";
import classnames from "classnames";
import SvgXLink from "components/SvgXLink";
import styles from "./price-category-list.scss";

const PriceCategoryList = ({ title, svg, items, className, ...props }) => (
  <article
    className={classnames(styles.priceCategoryList, className)}
    {...props}
  >
    <header className={styles.header}>
      <SvgXLink className={styles.icon} {...svg} />
      <h2 className={styles.title}>{title}</h2>
    </header>
    <table className={styles.list}>
      <tbody>
        {items.map(({ text, price, onRequest, fromPrice = false }, index) => (
          <tr key={index} className={styles.listRow}>
            <td className={styles.listRowText}>
              <span>{text}</span>
            </td>
            <td className={styles.listRowPrice}>
              {onRequest && (
                <span className={styles.listRowOnRequest}>Op aanvraag</span>
              )}
              {fromPrice && (
                <span className={styles.listRowFromPrice}>vanaf</span>
              )}
              {price !== undefined && (
                <span>€ {price.toFixed(2).replace(".", ",")}</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </article>
);

PriceCategoryList.propTypes = {
  title: string.isRequired,
  svg: shape(SvgXLink.PropTypes),
  items: arrayOf(
    oneOf([
      shape({
        text: string.isRequired,
        price: number.isRequired,
        fromPrice: bool
      }),
      shape({
        text: string.isRequired,
        onRequest: bool.isRequired
      })
    ])
  )
};

export default PriceCategoryList;
